<!--主页的学会通知卡片-->
<template>
  <div class="ann_box">
    <div style="padding-top:4px;text-align: center;width: 80px;height: 100%;float: left">
      <span style="font-size: 40px;color: #0052be;border-bottom: 1px solid #8e9aa9">{{annDay}}</span>
      <p style="font-size: 14px">{{annData}}</p>
    </div>
    <div style="width: 394px;height: 100%;float: left;padding-top: 8px;padding-left: 10px;padding-right: 10px">
      <p class="newitem-title" style="font-size: 12px">
        <router-link style="color: #000000" :to="'/noticeArticle/'+articleId+'/'+tabName" class="itemNotice-a">{{title}}</router-link>
      </p>
      <p class="newitem-text" style="font-size: 12px">
        {{annTest}}
        <router-link style="color:#337ab7" :to="'/noticeArticle/'+articleId+'/'+tabName" class="itemNotice-a">详情</router-link>
      </p>
    </div>
  </div>
</template>
<!--http://-->
<script>
export default {
  props: ['annDay', 'annData', 'annTest', 'articleId', 'tabName', 'title']
}
</script>

<style>
  .ann_box{
    width: 475px;
    height: 100px;
    background-color: #ccdcf2;
    float: left;
    border-bottom: 1px solid #ffffff;
    border-right: 1px solid #ffffff;
  }
  .newitem-title{
    margin-bottom: 4px;
    font-size: 14px;
    font-weight: 600
  }
  .newitem-text{
    margin-bottom: 8px;
    color: #999999;
    font-size: 12px;
    line-height: 20px;
  }
  .newitem-text a{
    color: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/components/news/announcement.vue